import { ALL_CATEGORY, GET_ALL_CATEGORY, LOG_OUT } from "../../types";

const initial_state = {
  all_category: [],
  get_all_categories: [],
};

export default function (state = initial_state, action) {
  switch (action.type) {
    case ALL_CATEGORY:
      return { ...state, all_category: action.payload };
    case GET_ALL_CATEGORY:
      return { ...state, get_all_categories: action.payload };
    // case LOG_OUT: {
    //   return {
    //     ...state,
    //     all_category: [],
    //     get_all_categories: [],
    //   };
    // }
    default:
      return state;
  }
}
